import { Rating } from './Rating';

export type { TypeRatingProps } from './types';
export default Rating;
